export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error('VITE_API_BASE_URL не задан. Настройте базовый URL API в переменных окружения.');
}

export function apiUrl(path = '') {
  if (!path) {
    return API_BASE_URL;
  }
  let normalizedPath = path;
  if (!normalizedPath.startsWith('/')) {
    normalizedPath = `/${normalizedPath}`;
  }
  return `${API_BASE_URL}${normalizedPath}`;
}

export function assetUrl(path = '') {
  if (!path) {
    return '';
  }
  try {
    return new URL(path, API_BASE_URL).toString();
  } catch (error) {
    return path;
  }
}
